export default [
	{
		path: '/reset_password',
		lazy: async () => {
			const Module = await import('../../pages/services/account/ResetPasswordPage');
			return { Component: Module.default };
		},
	},
];
